// extracted by mini-css-extract-plugin
export default {"descriptionBlockWrapper":"styles_descriptionBlockWrapper__K9O4D","titleWrapper":"styles_titleWrapper__wCNph","contentWrapper":"styles_contentWrapper__83nY9"};